import { gql } from '@/shared/graphql/generated/cache';

export const getRuntimeVersionQuery = gql(/* GraphQL */ `
  query GetRuntimeVersion {
    allEnvironmentAddresses {
      nodes {
        runtimeVersion
      }
    }
  }
`);

export const getBitcoinBoostSafeMode = gql(/* GraphQL */ `
  query GetBitcoinBoostSafeMode {
    allBoostSafeModes(filter: { chain: { equalTo: Bitcoin } }) {
      nodes {
        boostDepositsEnabled
      }
    }
  }
`);

export const BANNER_STATUS_QUERY = gql(/* GraphQL */ `
  query BannerStatus($app: App!) {
    banner: allBanners(filter: { or: [{ app: { equalTo: $app } }, { app: { equalTo: ALL } }] }) {
      nodes {
        message
        type
        linkUrl
        linkText
      }
    }
  }
`);
